/**
 * Every upstream Akash type the tenant surface registers, in one place.
 *
 * This exists because `messages.ts` and `deployment.ts` cannot compose it between
 * them: `deployment.ts` needs `DeploymentID` from `messages.ts`, so `messages.ts`
 * importing back the deployment registry is a cycle, and the eager spread in a
 * module-level array evaluates to `undefined` rather than failing — a registry
 * silently missing `MsgCreateDeployment` would surface as "unregistered type URL"
 * at signing time.
 *
 * The old name lives here now rather than in `messages.ts`, deliberately: an import
 * of `protocolRegistryTypes` from `./messages` no longer resolves, so a stale caller
 * fails to compile instead of quietly registering the smaller set.
 */

import type { GeneratedType } from '@cosmjs/proto-signing'

import { deploymentRegistryTypes } from './deployment'
import { escrowRegistryTypes } from './escrow'
import { messageRegistryTypes } from './messages'
import { rentalRegistryTypes } from './rental'

export const protocolRegistryTypes: ReadonlyArray<[string, GeneratedType]> = [
  ...messageRegistryTypes,
  ...deploymentRegistryTypes,
  // Without this, client.sign() throws "unregistered type URL" on the second
  // message of a direct rental — which is the good failure mode, but only
  // because it is registered here rather than assumed.
  ...rentalRegistryTypes,
  // Escrow top-up on a running deployment.
  ...escrowRegistryTypes,
]
